import View from './view.js'
import React, { useCallback, useEffect } from 'react'
import useIsHovered from 'Simple/hooks/useIsHovered.js'
import { useDataSubmit, useDataValue } from 'Simple/Data.js'

let BANNED_VIEW_PATHS = ['/TaskDoneAction', '/DueDate', '/Assignee']

export default function Logic(props) {
  let [hovered, , hoverBind] = useIsHovered({
    isDisabled: false,
    isSelected: false,
  })

  let task_id = useDataValue({
    viewPath: props.viewPath,
    context: 'card',
    path: 'id',
  })

  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  useEffect(() => {
    if (!props.moved) return
    let element = document.querySelector(`[data-view-path="${props.viewPath}"]`)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
    }
  }, [props.moved, props.viewPath])

  // onMouseUp won't turn Vertical into a <button>
  let onMouseUp = useCallback(
    event => {
      let isBannedViewPath =
        BANNED_VIEW_PATHS.some(viewPath =>
          event.target?.dataset?.viewPath?.includes(viewPath)
        ) || !event.target?.dataset?.viewPath

      if (isBannedViewPath) {
        return
      }

      submit({
        type: 'open_task_overlay',
        task_id,
      })
    },
    [task_id]
  )

  return (
    <View
      {...props}
      hovered={hovered}
      onMouseUp={onMouseUp}
      onMouseEnter={hoverBind.onMouseEnter}
      onMouseLeave={hoverBind.onMouseLeave}
    />
  )
}
